import { forwardRef } from 'react';
import { useMapTokenPropsToCSS } from '../../hooks/useMapTokenPropsToCSS';
import { filterProps } from '../filterProps';

/**
 * TODO: replace SpaceStyleProps with BaseStyleProps once it's available
 * (https://git.hubteam.com/HubSpot/foundations-components/pull/3781/files#diff-eadd11402bedf4de6705692b0cb986264d20cd8961f116f80459629e5b6767f1)
 */
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * HOC to provide the useMapTokenPropsToCSS hook to a class component.
 * @param WrappedComponent - The component to provide token props support to.
 * @returns A new component that has token props support.
 */
export function withTokenProps(WrappedComponent) {
  const displayName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
  const ComponentWithTokenProps = /*#__PURE__*/forwardRef((props, ref) => {
    const {
      tokenProps
    } = filterProps(props);
    const cssProps = useMapTokenPropsToCSS(tokenProps);
    const componentProps = Object.assign({}, props, {
      cssStyles: cssProps,
      ref
    });
    return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, componentProps));
  });
  ComponentWithTokenProps.displayName = `withTokenProps(${displayName})`;
  return ComponentWithTokenProps;
}